<template>
  <section>
    <!-- Image -->
    <div
      v-for="(item, index) in passSectionItemPost"
      :key="'img-' + index"
      class="px-4 sm:px-0 mb-4"
    >
      <img
        :src="`https://archivegazette.iwcdeped.com/${item.media_link}`"
        alt="IWC Logo"
        class="w-full h-auto object-cover rounded-lg"
      />
    </div>

    <!-- Title -->
    <div class="flex justify-center items-center py-2 sm:py-10 max-w-5xl mx-auto">
      <div v-for="(item, index) in passSectionItemPost" :key="'title-' + index">
        <h1
          class="text-2xl leading-snug sm:text-5xl sm:leading-normal text-center font-extrabold text-primarydark"
        >
          {{ item.title }}
        </h1>
      </div>
    </div>

    <!-- Content (Sanitized HTML) -->
    <div
      v-for="(item, index) in passSectionItemPost"
      :key="'content-' + index"
      class="prose max-w-full break-words text-sm sm:text-base md:text-lg py-2 px-4 sm:px-0 leading-7 sm:leading-10 md:leading-8 text-primarydark"
      v-html="sanitizeHtml(item.content)"
    ></div>
  </section>
</template>

<script>
import DOMPurify from 'dompurify';
export default {
  props: {
    passSectionItemPost: {
      type: Array,
      required: true
    }
  },
  setup() {
    const sanitizeHtml = (html) => {
      if (!html) return '';

      // Remove &nbsp;
      html = html.replace(/&nbsp;/g, ' ');

      // Remove multiple spaces
      html = html.replace(/\s{2,}/g, ' ');

      // Remove empty paragraphs like <p><br></p>
      html = html.replace(/<p>(\s|<br\s*\/?>)*<\/p>/gi, '');

      // Trim leading & trailing spaces
      html = html.trim();

      return DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
    };

    return { sanitizeHtml };
  }
};
</script>
